import moment from 'moment/moment'

export const deepCopyObject = (obj = {}) => JSON.parse(JSON.stringify(obj))

export const parseJson = (str, defaultValue = null) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export const getDiffDays = date => {
  const oneDay = 24 * 60 * 60 * 1000
  const firstDate = new Date()
  const secondDate = new Date(date)

  return Math.round(Math.abs((firstDate - secondDate) / oneDay))
}

export const getDiffTime = date => {
  if (date) {
    const now = moment(new Date()).utc(0)
    const then = moment(new Date(date)).utc(0)
    const ms = now.diff(then)
    return AddSecToMs(ms, 0)
  }
  return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    ms: 0
  }
}

export const AddSecToMs = (ms, sec = 1) => {
  const newMs = ms + sec * 1000
  const hours = moment.duration(newMs).hours()
  const minutes = moment.duration(newMs).minutes()
  const seconds = moment.duration(newMs).seconds()
  const days = Math.floor(moment.duration(newMs).asDays())
  return {
    days,
    hours,
    minutes,
    seconds,
    ms: newMs
  }
}
export const isObject = variable => {
  return (
    typeof variable === 'object' &&
    variable !== null &&
    !Array.isArray(variable)
  )
}

export const guaranteeKeysName = name => {
  switch (name) {
    case 'engine':
      return 'Двигатель'
    case 'transferCase':
      return 'Раздаточная коробка'
    case 'transmission':
      return 'КПП'
    case 'other':
      return 'Другие'
    case 'conditioningCompressor':
      return 'Компрессор кондиционера'
    case 'suspensionCompressor':
      return 'Компрессор подвески'
    case 'powerSteering':
      return 'Гидроусилитель руля'
    case 'steeringRack':
      return 'Рулевая рейка'
    case 'generator':
      return 'Генератор'
    case 'clutch':
      return 'Сцепление'
    case 'fuelPump':
      return 'Топливный насос'
    default:
      return name
  }
}

export const isExpiredEvent = event => {
  if (
    event.completedDate &&
    moment(event.completedDate).isAfter(moment(event.end))
  ) {
    return true
  }
  return (
    event.end && !event.completedDate && moment().isAfter(moment(event.end))
  )
}
export const clearObject = data =>
  Object.keys(data).reduce((acc, key) => {
    if (data[key] && Array.isArray(data[key]) && data[key]?.length > 0) {
      acc[key] = data[key]
    }
    if (
      data[key] &&
      typeof data[key] !== 'boolean' &&
      !Array.isArray(data[key])
    ) {
      acc[key] = data[key]
    }
    if (typeof data[key] === 'boolean') {
      acc[key] = data[key]
    }

    return acc
  }, {})

export const totalPrice = (arr, param = 'price') => {
  try {
    if (arr.length > 0 && arr?.[0]?.hasOwnProperty(param)) {
      let s = 0
      for (let i = 0; i < arr.length; i++) {
        s += Number(arr?.[i]?.[param]?.toString()?.replaceAll(' ', '') || 0)
      }
      return s.toLocaleString()
    } else {
      return '0'
    }
  } catch (e) {
    return '0'
  }
}

function decimalAdjust(type, value, exp) {
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value)
  }
  value = +value
  exp = +exp
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN
  }
  value = value.toString().split('e')
  value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)))
  value = value.toString().split('e')
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp))
}

export const mathCeil = (value, exp) => {
  return decimalAdjust('ceil', value, exp)
}

export const formatTime = milliseconds => {
  if (typeof milliseconds !== 'number') return '0'
  const seconds = Math.floor(milliseconds / 1000)
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}м ${secs}с`
}

export const toBase64 = async file =>
  await new Promise((resolve, reject) => {
    try {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
    } catch (e) {
      resolve(null)
    }
  })
